// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"0ad79aa7","431":"88e8cd37","489":"1b1e4e0b","507":"03594251","608":"47272cfd","787":"fd6a51ed","900":"50f58aea"}[chunkId] + ".chunk.js";
};